import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import NoResultsPage from '../../../components/no-results-page/NoResultsPage';
import Table from '../../../components/table/Table';
import TBody from '../../../components/table/TBody/TBody';
import TD from '../../../components/table/TD/TD';
import TH from '../../../components/table/TH/TH';
import THead from '../../../components/table/THead/THead';
import TR from '../../../components/table/TR/TR';
import { Color } from '../../../core/enums/Color';
import { RootState } from '../../../core/state/state';
import { getExternalUserContacts } from '../../../core/state/subcontractors/asyncActions';
import Badge from '../../components/badge/Badge';
import TableWrapper from '../../components/table-wrapper/TableWrapper';

import './ExternalUserContacts.scss';

const ExternalUserContacts: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const contacts = useSelector((state: RootState) => state.subcontractor.contacts);
  const { userId } = useParams<{ userId: string }>();

  React.useEffect(() => {
    dispatch(getExternalUserContacts(Number(userId)));
  }, [dispatch, userId]);

  return (
    <TableWrapper>
      <div className="table__header">
        <span>{t('externalUsers.companyContacts.title')}</span>
      </div>
      <div className="external-user-contacts__table">
        <Table>
          <THead>
            <TR>
              <TH>{t('common.contactName')}</TH>
              <TH>{t('common.companyNumber')}</TH>
            </TR>
          </THead>
          <TBody>
            {contacts?.map((contact) => (
              <TR key={contact.id}>
                <TD className="text-left">
                  <span className="font-weight-bold">{`${contact.firstName === 'Unknown' ? '-' : contact.firstName} ${
                    contact.lastName === 'Unknown' ? '-' : contact.lastName
                  }`}</span>
                </TD>
                <TD className="text-left">{contact.phoneNumber}</TD>
                <TD className="text-left">
                  {contact.isPrimary && <Badge label={t('externalUsers.companyContacts.primaryContact')} color={Color.LightBlue} />}
                </TD>
              </TR>
            ))}
          </TBody>
        </Table>
        {!contacts && (
          <NoResultsPage
            title={t('externalUsers.companyContacts.noContacts.title')}
            description={t('externalUsers.companyContacts.noContacts.text')}
            icon="roles"
            iconClass="external-user-contacts__no-results-icon"
          />
        )}
      </div>
    </TableWrapper>
  );
};

export default ExternalUserContacts;
